import logoUrl from '../../assets/_logo-smith-white.png';
import content from '../../content/homepage';

export function Footer() {
  const { footer } = content;

  return (
    <footer
      id="footer"
      aria-labelledby="footer-heading"
      className="border-t border-[color:var(--color-hairline)] bg-[color:var(--color-canvas)] py-[var(--spacing-section-sm)] md:py-[var(--spacing-section-md)]"
    >
      <h2 id="footer-heading" className="sr-only">
        {footer.srHeading}
      </h2>
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-10 px-6 text-center md:px-12">
        <img
          src={logoUrl}
          alt="Smith"
          width={812}
          height={152}
          loading="lazy"
          className="h-auto w-full max-w-[160px] opacity-80 md:max-w-[200px]"
        />

        <p className="font-sans text-xs tracking-[var(--tracking-eyebrow)] text-[color:var(--color-foreground)]/70 uppercase">
          {footer.tagline}
        </p>

        <div className="h-px w-24 bg-[color:var(--color-hairline)]" aria-hidden="true" />

        <ul className="flex flex-wrap justify-center gap-x-12 gap-y-4">
          {footer.links.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="font-sans text-sm tracking-[var(--tracking-button)] text-[color:var(--color-foreground)] uppercase transition-colors hover:text-[color:var(--color-accent)]"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <p className="font-body text-xs text-[color:var(--color-foreground)]/50">
          {footer.copyright}
        </p>
      </div>
    </footer>
  );
}
